module.exports = __webpack_public_path__ + "img/cooperate_qy_10@2x.026b7b84.png";